<template>
  <div class="plan-card">
    <!--
    <p class="title" v-bind:style="'border-bottom:2px solid ' + hrColor + ';'">
      {{ getFullImagePath()}}
    </p>
    -->
        <img :src="getFullImagePath()" alt="" width="50%" />

    <p class="price" v-if="firstPrice == true"></p>
    <p class="price" v-else>
      <strong>{{ "$" + firstPrice + ".-/mes" }}</strong>
      <span v-if="secondPrice != ''">
        <br />
      
      </span>
    </p>

    <ul class="listado">
      <li v-for="i in info" :key="i">{{ i }}</li>
    </ul>
    <button
      v-if="firstPrice && this.allData.person"
      @click="contactPlan"
      class="button is-info"
    >
      Contratar Plan
    </button>
  </div>
</template>

<script>
export default {
  name: "PlanCard",
  props: [
    "title",
    "hrColor",
    "firstPrice",
    "secondPrice",
    "planType",
    "allData",
    "info",
    "url_image"
  ],
  data() {
    return {
      plan: this.planType,
    };
  },
  methods: {
     getFullImagePath() {
      //return `./../../assets/${this.url_image}.svg`;
       return require(`./../../assets/${this.url_image}.svg`);
    },
    contactPlan() {
      this.$gtag.pageview({ page_title: "Contratar", page_path: "/contratar" });
      this.$router.push({
        name: "Contratar",
        params: {
          allData: this.allData,
          thisType: this.plan,
          firstPrice: this.firstPrice,
        },
      });
    },
  },
};
</script>

<style scoped>
ul.listado {
  text-align: left;
  max-width: 70%;
  margin: 0 auto;
  list-style: initial;
  padding-bottom: 10px;
  min-height: 250px;
}
ul.listado li {
  font-size: 16px;
}
.title {
  font-size: 24px;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.price strong {
  font-size: 36px !important;
  color: #00758f;
  line-height: 2.5;
}
button,
.button {
  width: 195px;
  max-width: 195px !important;
  margin: 0 auto;
  margin-top: 30px;
  background: #00758f !important;
  color: #fff;
  /* font-size: 24px; */
  color: #ffffff;
  display: block;
  text-transform: uppercase;
  border-radius: 0;
}
@media screen and (max-width: 480px) {
  .title {
    font-size: 17px;
  }
}
</style>
